module.exports = __webpack_public_path__ + "static/img/master-card.7e36edd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/payment-img/master-card.jpg
// module id = 1144
// module chunks = 4